var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGy = function SvgGy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#399408",
    d: "M2.426 0h637.557v480H2.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.167 0C-.67.073 619.765 241.48 619.765 241.48L-.005 479.77.166 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.28 20.186c3.462 0 559.053 217.89 555.893 220.03L1.867 463.266.287 20.186z",
    fill: "#ffde08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.863.783c1.848 0 290.94 240.92 290.94 240.92L1.863 476.983V.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.28 33.902c1.658-14.986 260.9 208.4 260.9 208.4L.268 451.702V33.912z",
    fill: "#de2110"
  }))));
};
export default __webpack_public_path__ + "assets/fcae52f4bb338b55e49813749159cf29.svg";
export { SvgGy as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gy.svg